export class TagEventVO {
    msFromStart;
    timeFromStart;
    type;
    uuid;
    tag;
    data;
    target;
    targetName;
    constructor(type = undefined, tag = undefined, data = undefined, target = undefined, targetName = undefined) {
        this.type = type;
        this.uuid = tag?.uuid;
        this.tag = tag;
        this.data = data;
        this.target = target;
        this.targetName = targetName;
    }
}
